/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Groups_TabInputs */



/**
* | output |
* | --- |
* | "Groups" |
*
* @param {Team_Manager_Groups_TabInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_groups_tab = /** @type {((inputs?: Team_Manager_Groups_TabInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Groups_TabInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gruppen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("团体")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupos")
	return /** @type {LocalizedString} */ ("Groups")
});